module.exports = __webpack_public_path__ + "img/image.9337b178.svg";